export default "__VITE_ASSET__f2874b81__"